<div class="form-field">
  <div class="querys-container" *ngIf="queries?.length">
    <label>Queries Present</label>
    <div class="query-container" *ngFor="let query of queries; let i = index">
      <p class="query-container-content">
        <span>{{ query?.key }} </span>
        <ng-container [ngSwitch]="query.operation">
          <span *ngSwitchCase="'match'">  exact match of  </span>
          <span *ngSwitchCase="'contains'">  contains  </span>
          <span *ngSwitchCase="'notContains'">  does not contain  </span>
        </ng-container>
        <span>"{{ query?.text }}"</span>
      </p>
      <button (click)="removeQuery(i)" pButton class="query-delete-btn">
        Delete
      </button>
    </div>
  </div>

  <div *ngIf="queries?.length > 1">
    <label>Match all or any one of the queries</label>
    <div class="radio-group-container" style="display: flex; align-items: center; flex-wrap: wrap;margin-bottom: 10px;margin-top: 5px;">
      <div class="radio-group-item">
        <p-radioButton variant="filled" inputId="and" name="conditions" value="and" [(ngModel)]="queryConditional" (onClick)="updateQueryConditional($event)"></p-radioButton>
        <label for="and">All</label>
      </div>
      <div class="radio-group-item">
        <p-radioButton variant="filled" inputId="or" name="conditions" value="or" [(ngModel)]="queryConditional" (onClick)="updateQueryConditional($event)"></p-radioButton>
        <label for="or">Any</label>
      </div>
    </div>
  </div>

  <label>Select a Field and Value to Filter On</label>

  <p-select style="margin-bottom :10px"  placeholder="Field to Query With" [options]="options" [(ngModel)]="selectedKey" optionLabel="name"
  optionValue="name" />


  <p-select style="margin-bottom :10px" ngDefaultControl placeholder="Operation to Query With" [options]="selectedOperationOptions" [(ngModel)]="selectedOperation" optionLabel="label"
  optionValue="value" />


  <input
    placeholder="Text to Query With"
    pInputText
    fluid
    style="padding: 0.4375rem 1rem; margin-left: 3px"
    [(ngModel)]="filterText"
  />
  <button
    [disabled]="!selectedKey || !selectedOperation || !filterText"
    pButton
    severity="primary"
    (click)="addQuery()"
  >
   Add Query
  </button>
</div>
